import React, { useEffect, useState } from 'react';
import { api } from '../services/api';

export function AdminPanel() {
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getRequests('submitted').then(d => { setRequests(d.requests || []); setLoading(false); });
  }, []);

  const validate = async (id: string) => {
    try {
      await api.updateStatus(id, 'validated');
      setRequests(prev => prev.filter(r => r.id !== id));
    } catch (e: any) { alert(e.message); }
  };

  return (
    <div>
      <h2>Administration — Demandes a valider</h2>
      <p style={{ color: '#666', fontSize: 14 }}>{requests.length} demande(s) en attente de validation</p>

      {loading ? <div>Chargement...</div> : requests.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 40, background: '#fff', borderRadius: 8 }}>
          Aucune demande en attente
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 16 }}>
          {requests.map(r => (
            <div key={r.id} style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: 16 }}>{r.title}</h3>
                  <p style={{ margin: '8px 0', fontSize: 14, color: '#555' }}>{r.description}</p>
                  <div style={{ fontSize: 12, color: '#999' }}>
                    {r.category && <span style={{ marginRight: 12 }}>Categorie : {r.category}</span>}
                    <span>{r.votes} vote(s)</span>
                    <span style={{ marginLeft: 12 }}>Par {r.submittedByUpn || 'Anonyme'}</span>
                  </div>
                  {r.originalText && (
                    <details style={{ marginTop: 8, fontSize: 13 }}>
                      <summary style={{ color: '#999', cursor: 'pointer' }}>Texte original</summary>
                      <p style={{ color: '#666', marginTop: 4, fontStyle: 'italic' }}>{r.originalText}</p>
                    </details>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 8, marginLeft: 16 }}>
                  <button onClick={() => validate(r.id)}
                    style={{ padding: '8px 20px', borderRadius: 4, border: 'none', background: '#1e7e34', color: '#fff', cursor: 'pointer', fontSize: 14 }}>
                    Valider
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
